import { IconStars } from 'components/icons/stars';

export const DEFAULT_ICON = IconStars;
